import { Box, Typography } from "@mui/material";
import CopyrightIcon from '@mui/icons-material/Copyright';
import { primaryColor } from "../../Util/UtilColor";

export default function FooterData() {
    return(
        <Box sx={{display: "flex", justifyContent: "center", paddingTop:"10px", paddingBottom: "10px"}}>
            <CopyrightIcon sx={{marginRight:"5px", color:"white"}}/>
            <Typography sx={{color:"white"}}>LOGISTICS.COM 2025 All Rights Reserved</Typography>
        </Box>
    )
}